"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/Felows.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c95e37"),
    marko_node0 = marko_createElement("div", {
        id: "felows"
      }, "0", null, 8, 0, {
        i: marko_const_nextId()
      })
      .e("h6", null, null, null, 1)
        .t("Intructors")
      .e("div", {
          "class": "position-relative mt-6"
        }, null, null, 1)
        .e("ul", {
            "class": "list-unstyled users-list m-0 d-flex align-items-center"
          }, null, null, 4)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-20.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-22.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-12.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-21.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
      .e("br", null, null, null, 0)
      .e("br", null, null, null, 0)
      .e("h6", null, null, null, 1)
        .t("Classmates")
      .e("div", {
          "class": "position-relative mt-6"
        }, null, null, 1)
        .e("ul", {
            "class": "list-unstyled users-list m-0 d-flex align-items-center"
          }, null, null, 7)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Alain Krich"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-15.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Berson Delano"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-25.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Xiona Peace"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-20.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Tchili Bertain"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-18.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Menlona Ivlaskiv"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-10.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Profile",
                "data-container": "#A-switch",
                "data-profile-id": "userID",
                title: "Tolla Nkombi"
              }, null, null, 1)
              .e("img", {
                  "class": "media-object rounded-circle",
                  src: "/images/portrait/small/avatar-s-23.jpg",
                  alt: "Avatar",
                  height: "44",
                  width: "44"
                }, null, null, 0)
          .e("li", {
              "class": "avatar pull-up my-0"
            }, null, null, 1)
            .e("a", {
                "data-render": "Mates",
                "data-container": "#A-switch",
                "data-class-id": "classID",
                "class": "center-align",
                title: "See All"
              }, null, null, 1)
              .e("i", {
                  "class": "bx bx-dots-horizontal-rounded grey lighten-2 rounded-circle font-medium-5",
                  style: "padding:10px;"
                }, null, null, 0)
      .e("br", null, null, null, 0)
      .e("br", null, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
